unit ULogisticOverview;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, DB, WEBLib.Grids, Vcl.StdCtrls, WEBLib.StdCtrls,
  Vcl.Controls, WEBLib.WebCtrls, XData.Web.Client;

type
  TfrmLogisticOverview = class(TForm)
    divLogisticContainer: THTMLDiv;
    divLogisticMainContainer: THTMLDiv;
    tblLogitic: TTableControl;
    procedure WebFormCreate(Sender: TObject);
    procedure WebFormShow(Sender: TObject);
    procedure WebFormClose(Sender: TObject; var Action: TCloseAction);
  private
    [async] procedure GetLaundry; async;
    procedure ShowHeaders;
  public
    { Public-Deklarationen }
  protected procedure LoadDFMValues; override; end;

var
  frmLogisticOverview: TfrmLogisticOverview;

implementation

uses
  UDatamodule, UHelper, UJSHelper, UResources, UErrorHandling;

{$R *.dfm}

procedure TfrmLogisticOverview.GetLaundry;
var
  LResponse: TXDataClientResponse;
  LaundryArray : TJSArray;
  JSObject : TJsObject;
  Laundry : TJSObject;
  I: Integer;
  Idx : Integer;
begin
  try
    LResponse :=
      await(
        TXDataClientResponse,
        UDM.XDataWebClient.RawInvokeAsync('ILaundry.GetLogisticLaundry',
        [])
      );

    if LResponse.StatusCode = 200 then
    begin
      THelper.DebugODS('Received Laundry');
      JSObject := LResponse.ResultAsObject;
      LaundryArray := TJSArray(JSObject['value']);

      tblLogitic.RowCount := LaundryArray.Length + 1;

      Idx := 0;

      for I := 0 to LaundryArray.Length - 1 do
      begin
        Idx := I + 1;

        Laundry := TJsObject(LaundryArray.Elements[I]);

        if Integer(Laundry.Properties['Gemeldet']) = 1 then
        begin
          tblLogitic.RowClassName[Idx] := 'wcCLLogisticRowGreen'
        end
        else
        begin
          tblLogitic.RowClassName[Idx] := 'wcCLLogisticRowRed'
        end;

        tblLogitic.Cells[0, Idx] := String(Laundry.Properties['Date']);
        tblLogitic.Cells[1, Idx] := String(Laundry.Properties['Time']);
        tblLogitic.Cells[2, Idx] := String(Laundry.Properties['KundeAnzeigename']);
        tblLogitic.Cells[3, Idx] := String(Laundry.Properties['Dirty']);
        tblLogitic.Cells[4, Idx] := String(Laundry.Properties['EmptyNeeded']);
        tblLogitic.Cells[5, Idx] := String(Laundry.Properties['EmptyBack']);
        tblLogitic.Cells[6, Idx] := String(Laundry.Properties['Comment']);
      end;

    end
    else
    begin
      MessageDlg('Laundry list not received. Status: ' + IntToStr(LResponse.StatusCode), mtInformation, [mbOk]);
    end;
  except
    on E: EXDataClientRequestException do
      begin
        TErrorHandling.DisplayServerError(E);
      end;
  end;
end;


procedure TfrmLogisticOverview.ShowHeaders;
begin
  tblLogitic.Cells[0,0] := 'Lieferdatum';
  tblLogitic.Cells[1,0] := 'Uhrzeit';
  tblLogitic.Cells[2,0] := 'Kunde';
  tblLogitic.Cells[3,0] := 'Schmutzwäsche';
  tblLogitic.Cells[4,0] := 'Leercontainer liefern';
  tblLogitic.Cells[5,0] := 'Leercontainer holen';
  tblLogitic.Cells[6,0] := 'Kommentar';

  tblLogitic.RowCount := 1;
end;


procedure TfrmLogisticOverview.WebFormClose(Sender: TObject;
  var Action: TCloseAction);
begin
  Action := TCloseAction.caFree;
end;


procedure TfrmLogisticOverview.WebFormCreate(Sender: TObject);
begin
  ShowHeaders;
end;


procedure TfrmLogisticOverview.WebFormShow(Sender: TObject);
begin
{$IFDEF PAS2JS}
  asm
    pas.UJSHelper.THTMLComponents.LogisticInit();
    pas.UJSHelper.THTMLComponents.CheckLanguage();
    pas.UJSHelper.THTMLComponents.SetEvents();
    pas.UJSHelper.THTMLComponents.Translations();
  end;
{$ENDIF}
  GetLaundry;
end;

procedure TfrmLogisticOverview.LoadDFMValues;
begin
  inherited LoadDFMValues;

  divLogisticContainer := THTMLDiv.Create('wcIDLogisticContainer');
  divLogisticMainContainer := THTMLDiv.Create('wcIDLogisticMainContainer');
  tblLogitic := TTableControl.Create('wcIDLogisticTbl');

  divLogisticContainer.BeforeLoadDFMValues;
  divLogisticMainContainer.BeforeLoadDFMValues;
  tblLogitic.BeforeLoadDFMValues;
  try
    Name := 'frmLogisticOverview';
    Width := 1098;
    Height := 866;
    CSSLibrary := cssBootstrap;
    ElementFont := efCSS;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -15;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnClose', 'WebFormClose');
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    SetEvent(Self, 'OnShow', 'WebFormShow');
    divLogisticContainer.SetParentComponent(Self);
    divLogisticContainer.Name := 'divLogisticContainer';
    divLogisticContainer.Left := 0;
    divLogisticContainer.Top := 0;
    divLogisticContainer.Width := 1098;
    divLogisticContainer.Height := 866;
    divLogisticContainer.HeightStyle := ssAuto;
    divLogisticContainer.WidthStyle := ssAuto;
    divLogisticContainer.Align := alClient;
    divLogisticContainer.ChildOrder := 2;
    divLogisticContainer.ElementPosition := epIgnore;
    divLogisticContainer.ElementFont := efCSS;
    divLogisticContainer.Role := '';
    divLogisticMainContainer.SetParentComponent(divLogisticContainer);
    divLogisticMainContainer.Name := 'divLogisticMainContainer';
    divLogisticMainContainer.Left := 0;
    divLogisticMainContainer.Top := 0;
    divLogisticMainContainer.Width := 1098;
    divLogisticMainContainer.Height := 866;
    divLogisticMainContainer.ElementClassName := 'wcCLMainContainer Container';
    divLogisticMainContainer.HeightStyle := ssAuto;
    divLogisticMainContainer.WidthStyle := ssAuto;
    divLogisticMainContainer.Align := alClient;
    divLogisticMainContainer.ElementPosition := epIgnore;
    divLogisticMainContainer.ElementFont := efCSS;
    divLogisticMainContainer.Role := '';
    tblLogitic.SetParentComponent(divLogisticMainContainer);
    tblLogitic.Name := 'tblLogitic';
    tblLogitic.Left := 125;
    tblLogitic.Top := 250;
    tblLogitic.Width := 705;
    tblLogitic.Height := 369;
    tblLogitic.ElementClassName := 'display wcCLTableOrders';
    tblLogitic.HeightStyle := ssAuto;
    tblLogitic.WidthStyle := ssAuto;
    tblLogitic.BorderColor := clSilver;
    tblLogitic.ChildOrder := 1;
    tblLogitic.ElementFont := efCSS;
    tblLogitic.ElementHeaderClassName := 'thead-light';
    tblLogitic.ElementPosition := epIgnore;
    tblLogitic.ElementTableClassName := 'table table-striped table-bordered  table-hover';
    tblLogitic.Font.Charset := DEFAULT_CHARSET;
    tblLogitic.Font.Color := clWindowText;
    tblLogitic.Font.Height := -16;
    tblLogitic.Font.Name := 'Tahoma';
    tblLogitic.Font.Style := [];
    tblLogitic.Footer.ButtonActiveElementClassName := 'btn btn-primary';
    tblLogitic.Footer.ButtonElementClassName := 'btn btn-light';
    tblLogitic.Footer.DropDownElementClassName := 'form-control';
    tblLogitic.Footer.InputElementClassName := 'form-control';
    tblLogitic.Footer.LinkActiveElementClassName := 'link-primary';
    tblLogitic.Footer.LinkElementClassName := 'link-secondary';
    tblLogitic.Footer.ListElementClassName := 'pagination';
    tblLogitic.Footer.ListItemElementClassName := 'page-item';
    tblLogitic.Footer.ListLinkElementClassName := 'page-link';
    tblLogitic.Header.ButtonActiveElementClassName := 'btn btn-primary';
    tblLogitic.Header.ButtonElementClassName := 'btn btn-light';
    tblLogitic.Header.DropDownElementClassName := 'form-control';
    tblLogitic.Header.InputElementClassName := 'form-control';
    tblLogitic.Header.LinkActiveElementClassName := 'link-primary';
    tblLogitic.Header.LinkElementClassName := 'link-secondary';
    tblLogitic.Header.ListElementClassName := 'pagination';
    tblLogitic.Header.ListItemElementClassName := 'page-item';
    tblLogitic.Header.ListLinkElementClassName := 'page-link';
    tblLogitic.ParentFont := False;
    tblLogitic.ColCount := 7;
  finally
    divLogisticContainer.AfterLoadDFMValues;
    divLogisticMainContainer.AfterLoadDFMValues;
    tblLogitic.AfterLoadDFMValues;
  end;
end;

initialization
  RegisterClass(TfrmLogisticOverview);

end.